export default __webpack_public_path__ + "static/media/news.2bbe06ac.png";